/* BAGGG storefront — cart drawer, collection filters, product page */
(function () {
  'use strict';
  var CFG = window.BAGGG || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };


  /* keep the sticky filter bar exactly below the sticky header */
  function syncHeaderHeight() {
    var h = document.querySelector('#shopify-section-header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }
  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);

  /* ---------------- mobile nav ---------------- */
  var navToggle = $('[data-nav-toggle]');
  if (navToggle) {
    navToggle.addEventListener('click', function () {
      var nav = $('[data-nav]');
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------------- cart drawer ---------------- */
  var drawer = function () { return $('[data-drawer]'); };

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var close = d.querySelector('.drawer__close');
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function replaceDrawer(html, open) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-drawer]');
    var old = drawer();
    if (!fresh || !old) return;
    var wasOpen = old.classList.contains('is-open');
    old.replaceWith(fresh);
    if (wasOpen || open) openDrawer();
  }

  async function syncCount() {
    try {
      var cart = await (await fetch(CFG.routes.cart + '.js')).json();
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) { /* the badge is cosmetic — never block the cart on it */ }
  }

  /* Sections rendered from the layout can only be refreshed through the
     `sections` parameter on the cart endpoints, not via ?sections= on the page. */
  async function cartRequest(url, payload, open) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: 'cart-drawer', sections_url: window.location.pathname }, payload))
    });
    var data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'cart error');
    if (data.sections && data.sections['cart-drawer']) replaceDrawer(data.sections['cart-drawer'], open);
    await syncCount();
    return data;
  }

  async function refreshDrawer(open) {
    try {
      // an empty update is a no-op that still re-renders the drawer
      await cartRequest(CFG.routes.cart_update, { updates: {} }, open);
    } catch (e) {
      if (open) openDrawer();
    }
  }

  async function addToCart(items, btn) {
    var label = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'adding…'; }
    try {
      await cartRequest(CFG.routes.cart_add, { items: items }, true);
    } catch (e) {
      console.error('[baggg] add failed', e);
      window.location.href = CFG.routes.cart;
    } finally {
      if (btn) { btn.disabled = false; if (label) btn.textContent = label; }
    }
  }

  async function changeLine(line, qty) {
    try { await cartRequest(CFG.routes.cart_change, { line: line, quantity: qty }, true); }
    catch (e) { console.error('[baggg] change failed', e); window.location.href = CFG.routes.cart; }
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); refreshDrawer(true); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(+rm.getAttribute('data-remove'), 0); return; }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart([{ id: +quick.getAttribute('data-quick-add'), quantity: 1 }], quick);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });


  /* ---------------- hover shots ----------------
     They carry no src in the HTML. A touch device can never hover, so it never loads them;
     a mouse device gets them once the page is done with the work that matters. */
  if (window.matchMedia && window.matchMedia('(hover:hover)').matches) {
    var loadHovers = function () {
      $$('img.card__hover[data-hover-src]').forEach(function (img) {
        img.src = img.getAttribute('data-hover-src');
        img.removeAttribute('data-hover-src');
      });
    };
    var whenIdle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 400); };
    if (document.readyState === 'complete') whenIdle(loadHovers);
    else window.addEventListener('load', function () { whenIdle(loadHovers); });
  }

  /* ---------------- collection filters ---------------- */
  var filters = $('[data-filters]');
  if (filters) {
    var grid = $('[data-grid]');
    var cards = $$('[data-card]', grid);
    var searchInput = $('[data-search]', filters);
    var countEl = $('[data-count]', filters);
    var clearBtns = $$('[data-clear]');
    var emptyEl = $('[data-empty]');
    var suggest = $('[data-suggest]');
    var suggestRow = $('[data-suggest-row]');
    var suggestColour = $('[data-suggest-colour]');
    var activeColour = null;

    // Every shade of a colour belongs to that colour — khaki and olive are green. One list,
    // ordered so the bags that lead in that colour come first.

    // When a colour is picked, show the bag IN that colour. Without this the grid
    // keeps its lead photo and filtering on "green" still looks like a wall of black.
    function paint(card, colour) {
      var img = card.querySelector('.card__main');
      if (!img) return;
      var sw = card.querySelector('.card__foot .swatch');
      if (!card._orig) {
        card._orig = {
          src: img.getAttribute('src'),
          srcset: img.getAttribute('srcset') || '',
          bg: sw ? sw.style.background : '',
          title: sw ? (sw.getAttribute('title') || '') : ''
        };
      }
      if (!card._fam) {
        try {
          card._fam = JSON.parse(card.getAttribute('data-famimg') || '{}');
          // stored short to keep the HTML small — put the CDN prefix back
          var base = card._orig.src.slice(0, card._orig.src.lastIndexOf('/') + 1);
          for (var k in card._fam) {
            if (card._fam[k].u.indexOf('/') === -1) card._fam[k].u = base + card._fam[k].u;
          }
        } catch (e) { card._fam = {}; }
      }
      var hit = colour && card._fam[colour];
      if (hit) {
        if (img.getAttribute('src') !== hit.u) { img.removeAttribute('srcset'); img.setAttribute('src', hit.u); }
        if (sw) { sw.style.background = hit.h; sw.setAttribute('title', hit.c); }
      } else {
        if (img.getAttribute('src') !== card._orig.src) {
          img.setAttribute('src', card._orig.src);
          if (card._orig.srcset) img.setAttribute('srcset', card._orig.srcset);
        }
        if (sw) { sw.style.background = card._orig.bg; sw.setAttribute('title', card._orig.title); }
      }
      card.classList.toggle('card--swapped', !!hit);
    }

    function apply() {
      var q = (searchInput.value || '').trim().toLowerCase();
      var shown = [];
      cards.forEach(function (card) {
        // match on any colour the bag actually comes in, not just its dominant one
        var fams = card.dataset.families || ('|' + card.dataset.family + '|');
        var okColour = !activeColour || fams.indexOf('|' + activeColour + '|') > -1;
        var okQuery = !q ||
          card.dataset.title.indexOf(q) > -1 ||
          card.dataset.spec.indexOf(q) > -1 ||
          card.dataset.family.indexOf(q) > -1 ||
          (card.dataset.shades || '').indexOf(q) > -1;
        var visible = okColour && okQuery;
        card.hidden = !visible;
        if (visible) {
          shown.push(card);
          paint(card, activeColour);
          if (activeColour) {
            var lead = fams.split('|').filter(Boolean)[0];
            var isLead = lead === activeColour;
            card.style.order = isLead ? '0' : '2';
          } else {
            card.style.order = '';
          }
        }
      });

      countEl.textContent = shown.length + ' ' + (countEl.getAttribute('data-noun') || 'STYLES')
        + (activeColour ? ' IN ' + activeColour.toUpperCase() : '');
      var any = !!q || !!activeColour;
      clearBtns.forEach(function (b) { b.hidden = !any; });
      if (emptyEl) emptyEl.hidden = shown.length !== 0;

      // "same colour, different bag" — only while searching a narrow result set
      if (suggest) {
        var show = q && shown.length > 0 && shown.length <= 6;
        if (show) {
          var fam = shown[0].dataset.family;
          var pool = cards.filter(function (c) { return c.dataset.family === fam && shown.indexOf(c) === -1; }).slice(0, 4);
          if (pool.length) {
            suggestColour.textContent = fam;
            suggestRow.innerHTML = '';
            pool.forEach(function (c) {
              var clone = c.cloneNode(true);
              clone.hidden = false;
              clone.removeAttribute('data-card'); // keep clones out of the filter set
              clone.classList.add('suggest__item');
              var quickLook = clone.querySelector('.card__quick');
              if (quickLook) quickLook.remove();
              var specEl = clone.querySelector('.card__spec');
              if (specEl) specEl.remove();
              suggestRow.appendChild(clone);
            });
            suggest.hidden = false;
          } else { suggest.hidden = true; }
        } else { suggest.hidden = true; }
      }
    }

    searchInput.addEventListener('input', apply);
    $$('[data-colour]', filters).forEach(function (dot) {
      dot.addEventListener('click', function () {
        var c = dot.getAttribute('data-colour');
        activeColour = activeColour === c ? null : c;
        $$('[data-colour]', filters).forEach(function (d) {
          var on = d.getAttribute('data-colour') === activeColour;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });
    clearBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        searchInput.value = '';
        activeColour = null;
        $$('[data-colour]', filters).forEach(function (d) { d.classList.remove('is-active'); d.setAttribute('aria-pressed', 'false'); });
        apply();
      });
    });

    // deep link: /collections/x?colour=black
    var params = new URLSearchParams(window.location.search);
    var pre = params.get('colour');
    if (pre) {
      var dot = $('[data-colour="' + pre.toLowerCase() + '"]', filters);
      if (dot) dot.click();
    }
    apply();
  }

  /* ---------------- recently viewed (per browser, nothing leaves the device) ---------------- */
  var recent = $('[data-recent]');
  if (recent) {
    var KEY = 'baggg:recent';
    var entry = null;
    try { entry = JSON.parse(recent.getAttribute('data-entry')); } catch (e) {}
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];

    var max = parseInt(recent.getAttribute('data-max'), 10) || 4;
    var others = list.filter(function (x) { return x && x.h && (!entry || x.h !== entry.h); }).slice(0, max);

    if (others.length) {
      var row = $('[data-recent-row]', recent);
      row.innerHTML = others.map(function (x) {
        return '<a class="card" href="' + x.u + '">' +
          '<div class="card__media"><img src="' + x.i + '" alt="" loading="lazy" width="500" height="625"></div>' +
          '<div class="card__foot"><div style="min-width:0">' +
            '<div class="card__name"></div><div class="card__spec"></div>' +
          '</div><div class="card__right"><span class="card__price"></span></div></div></a>';
      }).join('');
      // fill text via textContent so stored values can never inject markup
      $$('.card', row).forEach(function (card, i) {
        card.querySelector('.card__name').textContent = others[i].n || '';
        card.querySelector('.card__spec').textContent = others[i].s || '';
        card.querySelector('.card__price').textContent = others[i].p || '';
      });
      recent.hidden = false;
    }

    if (entry) {
      var next = [entry].concat(list.filter(function (x) { return x && x.h !== entry.h; })).slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* private mode */ }
    }
  }

  /* ---------------- product page ---------------- */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var galleryMap = {};
    try { galleryMap = JSON.parse(pdp.getAttribute('data-gallery') || '{}') || {}; } catch (e) { galleryMap = {}; }

    var mainImage = $('[data-main-image]', pdp);
    var thumbs = $$('[data-thumb]', pdp);
    var chips = $$('[data-chip]', pdp);
    var variantInput = $('[data-variant-id]', pdp);
    var pickImage = $('[data-pick-image]', pdp);
    var pickColour = $('[data-pick-colour]', pdp);
    var singlePrice = $('[data-single-price]', pdp);
    var addBtn = $('[data-add-btn]', pdp);

    function showImage(btn) {
      if (!btn || !mainImage) return;
      mainImage.src = btn.getAttribute('data-full');
      mainImage.alt = btn.getAttribute('data-alt') || '';
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === btn); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t); });
    });

    function selectColour(chip) {
      var colour = chip.getAttribute('data-colour');
      chips.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (variantInput) variantInput.value = chip.getAttribute('data-variant');

      // The thumbnail strip never changes — every shot of the bag, including the ones
      // on a person, stays reachable. Picking a colour only opens that colour's photo.
      var files = galleryMap[colour] || galleryMap[colour.replace(/ /g, '-')] || null;
      var firstVisible = null;
      thumbs.forEach(function (t) {
        t.hidden = false;
        if (files && !firstVisible && files.indexOf(t.getAttribute('data-file')) > -1) firstVisible = t;
      });
      if (firstVisible) {
        showImage(firstVisible);
      } else if (chip.getAttribute('data-image') && mainImage) {
        // no gallery entry for this colour — the variant's own photo still beats
        // leaving the shopper on the previous colour
        mainImage.src = chip.getAttribute('data-image');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      }

      if (pickColour) pickColour.textContent = colour;
      var pickSrc = firstVisible ? firstVisible.getAttribute('data-full') : chip.getAttribute('data-image');
      if (pickImage && pickSrc) pickImage.src = pickSrc;

      var priceText = chip.getAttribute('data-price-text');
      if (singlePrice && priceText) singlePrice.textContent = priceText;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', chip.getAttribute('data-variant'));
      window.history.replaceState({}, '', url);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { selectColour(chip); });
    });
    var activeChip = chips.filter(function (c) { return c.classList.contains('is-active'); })[0] || chips[0];
    if (activeChip) selectColour(activeChip);

    var form = $('[data-add-form]', pdp);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart([{ id: +variantInput.value, quantity: 1 }], addBtn);
      });
    }
  }

  /* ---------------- sticky buy bar ---------------- */
  var buybar = $('[data-buybar]');
  var realAdd = $('[data-add-btn]');
  if (buybar && realAdd) {
    document.body.classList.add('has-buybar');
    var lastTop = null;
    // one rect read per scroll — cheap, and free of rAF so it also works in background tabs
    var syncBar = function () {
      var top = window.scrollY;
      if (top === lastTop) return;
      lastTop = top;
      // show once the real button has scrolled past the top of the viewport
      buybar.hidden = realAdd.getBoundingClientRect().bottom > 0;
    };
    window.addEventListener('scroll', syncBar, { passive: true });
    window.addEventListener('resize', function () { lastTop = null; syncBar(); });
    syncBar();

    $('[data-buybar-add]', buybar).addEventListener('click', function () { realAdd.click(); });

    // keep the bar's price in step with the selected colour
    var priceEl = $('[data-buybar-price]', buybar);
    var singleEl = $('[data-single-price]');
    if (priceEl && singleEl) {
      new MutationObserver(function () { priceEl.textContent = singleEl.textContent; })
        .observe(singleEl, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---------------- wallet upsell + price explainer ---------------- */
  function toggleBlock(rootSel, btnSel, bodySel) {
    var root = $(rootSel);
    if (!root) return null;
    var btn = $(btnSel, root), body = $(bodySel, root);
    btn.addEventListener('click', function () {
      var open = body.hidden;
      body.hidden = !open;
      root.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    return { root: root, btn: btn, body: body };
  }

  toggleBlock('[data-whycost]', '[data-whycost-toggle]', '[data-whycost-body]');

  var wsell = toggleBlock('[data-walletsell]', '[data-walletsell-toggle]', '[data-walletsell-panel]');
  if (wsell) {
    var items = $$('[data-wsel]', wsell.root);
    var note = $('[data-walletsell-note]', wsell.root);
    var sub = $('[data-walletsell-sub]', wsell.root);
    var pct = wsell.root.getAttribute('data-pct');

    // family lookup mirrors snippets/colour-family.liquid
    var FAM = {
      black:'black', charcoal:'black', 'cow print black':'black',
      white:'beige', cream:'beige', beige:'beige', nude:'beige', camel:'beige',
      straw:'beige', taupe:'beige', 'cow print white':'beige', apricot:'beige',
      brown:'brown', 'dark brown':'brown', tan:'brown', cognac:'brown', bronze:'brown', rust:'brown', leopard:'brown',
      green:'green', olive:'green', khaki:'green', 'light green':'green', 'lime green':'green',
      'dark green':'green', 'mint green':'green', 'sage green':'green',
      yellow:'yellow', 'light yellow':'yellow', mustard:'yellow', orange:'yellow',
      red:'red', burgundy:'red', 'rose red':'red',
      pink:'pink',
      blue:'blue', 'light blue':'blue', navy:'blue', denim:'blue',
      grey:'grey', silver:'grey', 'light grey':'grey',
      purple:'purple'
    };

    function matchWallets(colour) {
      var c = (colour || '').toLowerCase();
      var fam = FAM[c] || 'other';

      // Lead with the shopper's colour, then deliberately mix: one wallet per
      // colour, cycling, so the row looks like a spread rather than a monochrome list.
      var lead = [], pool = [];
      items.forEach(function (el) {
        var ec = el.getAttribute('data-colour');
        var ef = el.getAttribute('data-family');
        if (ec === c || (ef === fam && fam !== 'other')) lead.push(el);
        else pool.push(el);
      });
      var matched = lead.length > 0;
      lead = lead.slice(0, 2);                       // a nod to the bag, not a theme

      var byColour = {};
      pool.forEach(function (el) {
        var k = el.getAttribute('data-colour');
        (byColour[k] = byColour[k] || []).push(el);
      });
      var keys = Object.keys(byColour);
      var mixed = [], i = 0, taken = true;
      while (taken) {                                 // round-robin across colours
        taken = false;
        keys.forEach(function (k) {
          if (byColour[k][i]) { mixed.push(byColour[k][i]); taken = true; }
        });
        i++;
      }

      var order = lead.concat(mixed);
      order.forEach(function (el, n) { el.hidden = false; el.style.order = n; });
      items.forEach(function (el) { if (order.indexOf(el) === -1) el.hidden = false; });

      if (note) {
        note.innerHTML = matched
          ? 'Starting with wallets that go with <b>' + c + '</b> — every one below is ' + pct + '% off with this bag.'
          : 'Every wallet below is ' + pct + '% off when it ships with this bag.';
      }
      if (sub) {
        var walletFree = wsell.root.getAttribute('data-walletfree') === '1';
        sub.textContent = walletFree
          ? pct + '% off, and it lifts your order to free shipping'
          : pct + '% off any wallet when it ships with your bag';
      }
    }

    // re-sort whenever the shopper picks a different colour
    var chipList = $$('[data-chip]');
    chipList.forEach(function (chip) {
      chip.addEventListener('click', function () { matchWallets(chip.getAttribute('data-colour')); });
    });
    var active = chipList.filter(function (c) { return c.classList.contains('is-active'); })[0] || chipList[0];
    matchWallets(active ? active.getAttribute('data-colour') : '');
  }
})();
